import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 bg-primary-500">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-semibold text-background-50">
          准备好领取你的第一份彩金了吗？
        </h2>
        <p className="mt-3 text-sm md:text-base text-primary-100 leading-relaxed max-w-lg mx-auto">
          浏览最新优惠活动，选择最适合你的平台，立即开启免费体验之旅
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/latest-promotions"
            className="px-6 py-3 rounded-full bg-background-50 text-primary-600 font-medium text-sm md:text-base hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看最新优惠
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/category/newbie-tutorial"
            className="px-6 py-3 rounded-full bg-primary-600 text-background-50 font-medium text-sm md:text-base hover:bg-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            新手入门教程
          </Link>
        </div>
      </div>
    </section>
  );
}